import { render, staticRenderFns } from "./DesktopInlineA.vue?vue&type=template&id=2804cfc0"
import script from "./DesktopInlineA.vue?vue&type=script&lang=js"
export * from "./DesktopInlineA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports